import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-92">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-93">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center" data-id="element-94">
          <div className="order-2 md:order-1 flex flex-col items-start" data-id="element-95">
            <FadeIn data-id="element-96">
              <span className="inline-block text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-97">
                Para mujeres 40+
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-98">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-teal mb-6" data-id="element-99">
                Protocolo Anti-Inflamatorio 40+: <br data-id="element-100" />
                <span className="italic font-light text-teal/80" data-id="element-101">
                  El Reset de 7 días
                </span>{' '}
                para recuperar tu cintura y tu energía
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-102">
              <p className="text-lg md:text-xl text-teal/70 mb-10 leading-relaxed font-light max-w-lg" data-id="element-103">
                Desactivá la "panza de estrés", eliminá la retención de líquidos
                y volvé a usar la ropa que amas sin dietas restrictivas ni
                ejercicios agotadores.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} className="w-full sm:w-auto" data-id="element-104">
              <Button href="#oferta" onClick={() => trackAddToCart({
              content_name: 'Protocolo Anti-Inflamatorio 40+',
              content_ids: ['55161732006179'],
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            })} className="w-full sm:w-auto" data-id="element-105">
                ¡Sí, quiero empezar mi reset!
              </Button>
              <div className="flex items-center gap-2 mt-4 text-sm text-teal/60 font-light" data-id="element-106">
                <ShieldCheck size={16} className="text-gold" data-id="element-107" />
                <span data-id="element-108">Acceso inmediato vía Hotmart</span>
              </div>
            </FadeIn>
          </div>

          <div className="order-1 md:order-2 relative" data-id="element-109">
            <FadeIn delay={0.2} data-id="element-110">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] md:aspect-auto md:h-[600px] shadow-2xl" data-id="element-111">
                <div className="absolute inset-0 bg-teal/5 mix-blend-multiply z-10" data-id="element-112"></div>
                <img src="https://cdn.magicpatterns.com/uploads/p6vPPrEpHBkZN63nriwz6L/heylloyd-image-1779162109607.png" alt="Protocolo Anti-Inflamatorio 40+ en dispositivo móvil" className="w-full h-full object-cover object-center" data-id="element-113" />
              </div>
              {/* Decorative element */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gold/10 rounded-full blur-2xl -z-10" data-id="element-114"></div>
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-teal/10 rounded-full blur-2xl -z-10" data-id="element-115"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}